export const DH = {
  AppLoader: `app-loader`,
  Container: `page-container`,
  Header: `page-header`,
  Title: `app-title`,
  Subtitle: `app-subtitle`,
  AddPaymentMethodButton: `add-pm-button`,

  AddNewCardModal: {
    Container: `add-new-card-container`,
    SubmitButton: `add-new-card-submit-btn`,
  },

  EmptyView: {
    Container: `empty-view.container`,
    Title: `empty-view.title`,
    Subtitle: `empty-view.subtitle`,
  },

  CardsListContainer: `cards-list-container`,
  CardsListInnerWrapper: {
    Desktop: `cards-list-inner-wrapper-desktop`,
    Mobile: `cards-list-inner-wrapper-mobile`,
  },

  DesktopTableHeader: {
    Card: `card-column-header`,
    Expire: `expire-column-header`,
  },

  ActionButtons: {
    Container: `action-buttons.container`,
    RequestRemoval: `action-buttons.request-removal`,
    ConfirmRemoval: `action-buttons.confirm-removal`,
    DeclineRemoval: `action-buttons.decline-removal`,
  },

  CardRow: {
    Header: `card-row.header`,
    WrapperBase: `card-row.wrapper-base`,
    ContainerBase: (cardId: string) => `card-row.container-base-${cardId}`,
    PrimaryLabel: `card-row.primary`,
    Number: `card-row.number`,
    ExpireDate: `card-row.expire-date`,
    SetAsPrimary: `card-row.set-as-primary`,
    BackButton: `card-row.back-button`,
  },

  CardDetails: {
    Container: `card-details.container`,
    BillingAddress: `card-details.billing-address`,
  },

  Error: {
    Fetch: {
      Container: `fetch-error-message.container`,
      Retry: `fetch-error-message.retry`,
    },
  },

  Toast: {
    FailedToDelete: `toast.failed-to-delete`,
    FailedToSetAsPrimary: `toast.set-as-primary`,
    CardAdded: `toast.card-added`,
  },

  BaseLoader: `base-loader`,
} as const;
